@if (isLink(item) && !isFunction(item.route)) {
  <a
    [fragment]="item.fragment"
    [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
    [routerLink]="item.route"
    [matTooltipDisabled]="!showTooltip"
    [matTooltip]="item.label | translate"
    matTooltipPosition="right"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    class="rms-sidenav-item rounded"
    matRipple
    matRippleColor="var(--rms-sidenav-item-ripple-color)"
    routerLinkActive="rms-sidenav-item--active"
    [ngClass]="isHover || linkElement.isActive ? item.hoverBgClass : ''"
    #linkElement="routerLinkActive">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover || linkElement.isActive ? item.hoverIcon || item.icon : item.icon"
        class="rms-sidenav-item__icon" />
    }
    <span class="rms-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[
          item.badge.bgClass,
          item.badge.textClass,
          linkElement.isActive ? item.badge.activeBgClass || '' : ''
        ]"
        [style.background-color]="
          linkElement.isActive && item.badge.activeBgColor ? item.badge.activeBgColor : item.badge.bgColor
        "
        class="rms-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
  </a>
}

@if (isLink(item) && isFunction(item.route)) {
  <div
    (click)="item.route()"
    (keydown.enter)="item.route()"
    class="rms-sidenav-item rounded"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    matRipple
    matRippleColor="var(--rms-sidenav-item-ripple-color)"
    routerLinkActive="rms-sidenav-item--active"
    tabindex="0"
    role="button"
    #linkElement="routerLinkActive">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover || linkElement.isActive ? item.hoverIcon || item.icon : item.icon"
        class="rms-sidenav-item__icon" />
    }
    <span class="rms-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        [style.background-color]="item.badge.bgColor"
        class="rms-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
  </div>
}

@if (isExternalLink(item)) {
  <a
    [href]="item.url"
    [matTooltipDisabled]="!showTooltip"
    [matTooltip]="item.label | translate"
    matTooltipPosition="right"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    [ngClass]="isHover ? item.hoverBgClass : ''"
    class="rms-sidenav-item rounded"
    matRipple
    matRippleColor="var(--rms-sidenav-item-ripple-color)"
    rel="noopener noreferrer"
    target="_blank">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover ? item.hoverIcon || item.icon : item.icon"
        class="rms-sidenav-item__icon" />
    }
    <span class="rms-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        [style.background-color]="item.badge.bgColor"
        class="rms-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
    <mat-icon
      class="rms-sidenav-item__external-icon"
      svgIcon="remix:System/external-link-line" />
  </a>
}

@if (isCallback(item)) {
  <div
    (click)="item.onClick()"
    (keydown.enter)="item.onClick()"
    [matTooltipDisabled]="!showTooltip"
    [matTooltip]="item.label | translate"
    matTooltipPosition="right"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    [class.rms-sidenav-item--active]="item.isActive"
    [ngClass]="isHover || item.isActive ? item.hoverBgClass : ''"
    class="rms-sidenav-item rounded"
    matRipple
    matRippleColor="var(--rms-sidenav-item-ripple-color)"
    tabindex="0"
    role="button">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover || item.isActive ? item.hoverIcon || item.icon : item.icon"
        class="rms-sidenav-item__icon" />
    }
    <span class="rms-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        class="rms-sidenav-item__badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass, item.isActive ? item.badge.activeBgClass || '' : '']"
        [style.background-color]="
          item.isActive && item.badge.activeBgColor ? item.badge.activeBgColor : item.badge.bgColor
        "
        [class.rms-sidenav-item__badge--empty]="!item.badge.value"
        >{{ item.badge.value }}</span
      >
    }
  </div>
}

@if (isDropdown(item)) {
  <div
    (click)="toggleOpen()"
    (keydown.enter)="toggleOpen()"
    [class.rms-sidenav-item--active]="isOpen || isActive"
    [class.rms-sidenav-item--open]="isOpen"
    class="rms-sidenav-item rounded"
    matRipple
    matRippleColor="var(--rms-sidenav-item-ripple-color)"
    tabindex="0"
    role="button">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover ? item.hoverIcon || item.icon : item.icon"
        class="rms-sidenav-item__icon" />
    }
    <span class="rms-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        [style.background-color]="item.badge.bgColor"
        class="rms-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
    <mat-icon
      class="rms-sidenav-item__dropdown-icon"
      svgIcon="mat:keyboard_arrow_right" />
  </div>
  <div
    [@dropdown]="isOpen"
    class="rms-sidenav-item__dropdown">
    @for (subItem of item.children; track subItem) {
      <rms-sidenav-item
        [item]="subItem"
        [level]="level + 1" />
    }
  </div>
}

@if (isSubheading(item)) {
  <div class="rms-sidenav-subheading">{{ item.label | translate }}</div>
  @for (subItem of item.children; track subItem) {
    <rms-sidenav-item
      [item]="subItem"
      [level]="0" />
  }
}
